import React from 'react';


const BillingSupport = () => (
  <div className="content">
    <div className="container">
      <div>
        <h3>How do I log on to my account?</h3>
        <p>
          If you dont know your log on information,
          please contact nakednews customer support by clicking{' '}
          <a href="/contact">
            here
          </a>{' '}
          Otherwise, use the correct login link above.
        </p>
      </div>
      <div>
        <h3>How do I cancel my subscription?</h3>
        <p>
          To cancel your subscription, please contact
          nakednews customer support by clicking{' '}
          <a href="/contact">
            here.
          </a>
        </p>
      </div>
      <div>
        <h3>Billing support</h3>
        <p>
          For users which created the subscription using
          Epoch service,{' '}
          <a href="https://epoch.com/billingsupport">
            here
          </a>{' '}
          is the billing support.
        </p>
        <p>
          For users which created the subscription using
          Segpay or Granity-TLE.com service,{' '}
          <a href="https://cs.segpay.com/">here</a>{' '}
          is the billing support.
        </p>
        <p>
          For users which created the subscription using
          Paysafe service,{' '}
          <a href="https://www.paysafecard.com/en-gb/help/contact-form/">
            here
          </a>{' '}
          is the billing support.
        </p>
      </div>
      <div>
        <h3>I still need help or have a question</h3>
        <p>
          For all inquires, please contact nakednews
          customer support by clicking{' '}
          <a href="/contact">
            here.
          </a>
        </p>
      </div>
      <div>
        <h3>Why am I being charged by Egalaxy Multimedia Inc?</h3>
        <p>If you are being charged by Egalaxy Multimedia Inc, you have a subscription to one of the following sites:</p>
        <ul style={{ paddingTop: '10px' }}>
          <li>Naked News (log in at <a href="/account/login">https://www.nakednews.com/account/login</a>)</li>
          <li>Mr. Skin (log in at <a href="https://www.mrskin.com/account/login">https://www.mrskin.com/account/login</a>)</li>
          <li>Naked News Cams (log in at <a href="https://www.streamate.com/login.php">https://www.streamate.com/login.php</a>)</li>
          <li>Playboy Plus (log in at <a href="https://login.playboy.com/cas/login?service=pbplus_production">https://login.playboy.com/cas/login?service=pbplus_production</a>)</li>
        </ul>
        <p>Credit card transactions and subscriptions for nakednews are handled by Egalaxy Multimedia Inc.</p>
      </div>
    </div>
  </div>
);

export default BillingSupport;
